export const getBrandName = () => {
  return process.env.REACT_APP_WEBSITE_BRAND.toLowerCase()
}

export const getServiceBrandName = () => {
  const brand = getBrandName()
  switch (brand) {
    case 'vw6':
      return 'vw'
    case 'dealer':
      return 'vw'
    case 'vwcv':
      return 'vwn'
    default:
      return brand
  }
}

export const getCookieControlBrandName = () => {
  const brand = getBrandName()
  switch (brand) {
    case 'vwcv':
    case 'vwn':
    case 'vw':
    case 'dealer':
      return 'vw6'
    default:
      return brand
  }
}

export const getBronsonBrand = (brand = getBrandName()) => {
  switch (brand) {
    case 'vwfs':
      return 'bluelabel'
    case 'dealer':
      return 'bluelabel'
    case 'vw':
    case 'vwcv':
    case 'vwn':
      return 'vw6'
    default:
      return brand
  }
}

export const getHeadlessCmsBrandName = () => {
  const brand = getBrandName()
  switch (brand) {
    case 'vw6':
    case 'vwfs':
    case 'dealer':
      return 'vw'
    default:
      return brand
  }
}

export const getTranslationPathBrandName = () => {
  const brand = getBrandName()
  switch (brand) {
    case 'vw':
    case 'dealer':
      return 'vw6'
    default:
      return brand
  }
}

export const getManufacturerName = () => {
  return getServiceBrandName()
}
